import type { RendererProps } from "../core/element-registry"
import { ElementRenderer } from "./element-renderer"
import { cn } from "../lib/utils"

export function TimelineRenderer({ element }: RendererProps) {
  const children = element.children ?? []

  return (
    <div
      className={cn("flex flex-col", element.className)}
      data-testid={`timeline-${element.id}`}
    >
      {children.map((child, i) => {
        const isLast = i === children.length - 1
        return (
          <div key={child.id} className="flex flex-row gap-3 items-stretch">
            {/* Dot + line column */}
            <div className="flex flex-col items-center w-6">
              <div className="w-2.5 h-2.5 rounded-full bg-primary mt-1.5 flex-shrink-0" />
              {!isLast && <div className="w-px flex-1 bg-border" />}
            </div>
            {/* Content */}
            <div className={cn("flex-1", !isLast && "pb-6")}>
              <ElementRenderer element={child} />
            </div>
          </div>
        )
      })}
    </div>
  )
}
